export default function UsBankIcon() {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect y="0.996094" width="39.999" height="39.999" rx="8" fill="white" />
      <path
        d="M5 9.58984V27.2998L20.0001 32.4037L35 27.2998V9.58984H5Z"
        fill="#D62A43"
      />
      <path
        d="M19.9909 26.7431H15.4046V25.1585H15.3577C14.4697 26.4075 13.196 27.0552 11.2991 27.0552C9.06718 27.0552 7.02489 25.6866 7.02489 22.829V14.2806H11.7795V20.8122C11.7795 22.2538 11.9461 23.2608 13.3398 23.2608C14.1563 23.2608 15.2365 22.8529 15.2365 20.8603V14.2808H19.9909V26.7431Z"
        fill="white"
      />
      <path
        d="M28.8526 17.9077C28.8288 17.4989 28.6135 17.1868 28.3012 16.9708C28.0126 16.7308 27.6275 16.6105 27.2446 16.6105C26.5705 16.6105 25.8028 16.7554 25.8028 17.5715C25.8028 17.9324 26.0914 18.0996 26.3554 18.2187C27.1481 18.5554 28.9484 18.6512 30.5335 19.1787C32.1184 19.6833 33.5112 20.6201 33.5112 22.6617C33.5112 26.118 30.1979 27.0554 27.1716 27.0554C24.2421 27.0554 21.0242 25.8794 20.9533 22.6617H25.49C25.5147 23.0938 25.7068 23.4536 26.0677 23.765C26.307 23.9817 26.7644 24.1261 27.3393 24.1261C27.964 24.1261 28.9482 23.8868 28.9482 23.1647C28.9482 22.445 28.54 22.2289 26.3307 21.8447C22.7056 21.221 21.2409 20.0687 21.2409 17.9324C21.2409 14.7866 24.627 13.9682 27.124 13.9682C29.8133 13.9682 33.0549 14.7149 33.1733 17.908L28.8526 17.9077Z"
        fill="white"
      />
    </svg>
  );
}
